export default __webpack_public_path__ + "static/media/workspace.4b95a2ff.jpg";